var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOracle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D7D8D9;}\n\t.st1{fill:#EA1B22;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,3.3C35.2,3.3,35.1,3.2,35.2,3.3C35.1,3.2,35.2,3.3,35.2,3.3L35.2,3.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25,
    cy: 25,
    r: 24
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.2,14.2H18.8C12.8,14.2,8,19.1,8,25c0,5.9,4.8,10.7,10.8,10.7h12.5C37.2,35.8,42,30.9,42,25 C42,19.1,37.2,14.2,31.2,14.2z M31,32H19c-3.8,0-7-3.1-7-6.9c0-3.8,3.1-7,7-7H31c3.8,0,7,3.1,7,7C37.9,28.9,34.8,32,31,32z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracle);
export default __webpack_public_path__ + "static/media/oracle.e1f946da9035fc5a9646f95284eb9f8b.svg";
export { ForwardRef as ReactComponent };